import React from 'react';
import { XIcon, CheckIcon, AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { rootCauses, withoutSystem, withSystem } from '../../data/content';
export function Problem() {
  return <section className="bg-ink-900 px-4 py-12 sm:py-16" data-id="element-211" data-mp="2rn3v7ztka2zr">
      <div className="mx-auto max-w-2xl lg:max-w-5xl" data-id="element-212" data-mp="2mpk5a2ni41rz">
        <h2 className="text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-213" data-mp="2mosj1ifsnged">
          Meno rifiniture.
          <br data-id="element-214" data-mp="2hnuveqc0lu5h" />
          <span className="text-brand-400" data-id="element-215" data-mp="2cre3rm5lwxnn">Più controllo. Più redditività.</span>
        </h2>

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/70" data-id="element-216" data-mp="28pj22gjrki9c">
          Ogni rifinitura significa più appuntamenti, più tempo alla poltrona, maggiore
          usura e minore profitto per il tuo studio.
        </p>

        <div className="mx-auto mt-6 max-w-xl rounded-2xl border border-alert-500/30 bg-alert-500/5 p-4" data-id="element-217" data-mp="6xnyko7nvk27">
          <div className="flex items-start gap-2.5" data-id="element-218" data-mp="1zurlsyjam0v">
            <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert-500" aria-hidden="true" data-id="element-219" data-mp="14ak6zooj2fi9" />
            <p className="text-[15px] font-semibold leading-relaxed text-white" data-id="element-220" data-mp="19bgai14yvzn5">
              La maggior parte di queste rifiniture non inizia alla fine del trattamento.
              <span className="mt-1 block text-alert-500" data-id="element-221" data-mp="10ai276nhx5yr">Inizia molto prima.</span>
            </p>
          </div>
          <ul className="mt-4 grid grid-cols-2 gap-2" data-id="element-222" data-mp="1o0ci5x343an8">
            {rootCauses.map(cause => <li key={cause} className="rounded-xl bg-ink-800 px-3 py-2.5 text-[12.5px] font-semibold leading-tight text-white/80 sm:text-sm" data-id="element-223" data-mp="1rzcy97u7fz6j">
                {cause}
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-[15px] leading-relaxed text-white/70" data-id="element-224" data-mp="26xnbl122b9ur">
          Il <strong className="font-bold text-white" data-id="element-225" data-mp="2bpoxzfsy2gyi">Sistema Anti-Rifiniture™</strong>{' '}
          riunisce protocolli clinici che ti aiutano a individuare questi errori prima che
          si trasformino in mesi aggiuntivi di trattamento.
        </p>

        <h3 className="mt-12 text-center font-display text-[22px] leading-tight text-white sm:text-3xl" data-id="element-226" data-mp="2gjonysb7hqc7">
          Da trattamenti imprevedibili… a casi molto più prevedibili.
        </h3>

        <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-227" data-mp="26pfua1afvrcg">
          <div className="rounded-2xl border border-alert-500/25 bg-ink-800 p-4" data-id="element-228" data-mp="22mtamnnx9cqc">
            <div className="flex items-center gap-2 border-b border-white/10 pb-3" data-id="element-229" data-mp="1xuhzeonqe4ih">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-alert-500/15 text-alert-500" data-id="element-230" data-mp="1svowtr9zfxx3">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-231" data-mp="1nxn2ubb0qe6u" />
              </span>
              <h4 className="text-[15px] font-black uppercase tracking-wide text-alert-500" data-id="element-232" data-mp="1ixitd58j2jq4">
                Senza un sistema
              </h4>
            </div>
            <ul className="mt-3 space-y-2.5" data-id="element-233" data-mp="1eya3wckit80d">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-white/70" data-id="element-234" data-mp="3qj9agj4xjxgt">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert-500" aria-hidden="true" data-id="element-235" data-mp="3ujaznsthayf7" />
                  <span className="leading-snug" data-id="element-236" data-mp="8efpi5dbuye6">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-brand-500/40 bg-ink-800 p-4 shadow-[0_0_0_1px_rgba(23,195,178,0.15)]" data-id="element-237" data-mp="36wuu8xwok999">
            <div className="flex items-center gap-2 border-b border-white/10 pb-3" data-id="element-238" data-mp="3bsjul3gixu6m">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-500/15 text-brand-400" data-id="element-239" data-mp="3gs4qt64b7ofn">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="3lmippii6kdp2" />
              </span>
              <h4 className="text-[15px] font-black uppercase tracking-wide text-brand-400" data-id="element-241" data-mp="2o4s9bad0a6t7">
                Con il Sistema
              </h4>
            </div>
            <ul className="mt-3 space-y-2.5" data-id="element-242" data-mp="yn4zelxiqpjn">
              {withSystem.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-white" data-id="element-243" data-mp="un4c0bsfz40g">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-244" data-mp="18e9h3tekwoi6" />
                  <span className="leading-snug" data-id="element-245" data-mp="13kwshj9wghpf">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-246" data-mp="1ddcc0l0uhecf">
          <CTAButton label="Voglio ridurre le mie rifiniture" sublabel="Accesso immediato per €19" data-id="element-247" data-mp="1dcjemans016y" />
        </div>
      </div>
    </section>;
}